import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { equipmsalinstance } from "../auth/EquipMsalClient";
import { equipOptionsInstance } from "@/models/EquipOptions";

export function setEquipApiBaseUrl(url: string) {
  axiosInstance.defaults.baseURL = url;
}

export const axiosInstance = axios.create({
  baseURL: equipmsalinstance.GetBaseUrl(),
  timeout: 60_000,
});

async function attachEquipToken(
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> {
  try {
    const token = await equipmsalinstance.GetToken();
    if (token) config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  } catch (err) {
    return Promise.reject(err);
  }
}

axiosInstance.interceptors.request.use(attachEquipToken, (error) => Promise.reject(error));

export async function Get<T>(url: string, params: Record<string, any> = {}): Promise<T> {
  try {
    const response = await axiosInstance.get<T>(url, {
      params,
    });

    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    console.warn(`GET ${url} failed:`, axiosError.response?.data || axiosError.message);
    throw error;
  }
}

export async function Post<T, TRequest = unknown>(
  url: string,
  data: TRequest,
  params?: Record<string, unknown>,
  headers?: Record<string, string>
): Promise<T> {
  try {
    const { data: resp } = await axiosInstance.post<T>(url, data, {
      params,
      headers,
    });
    return resp;
  } catch (error) {
    const axiosError = error as AxiosError;
    console.warn(`POST ${url} failed:`, axiosError.response?.data || axiosError.message);
    throw error;
  }
}
